import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import { AuthProvider, useAuth } from './context/AuthContext';
import PostListPage from './pages/PostListPage';
import PostCreatePage from './pages/PostCreatePage';
import PostDetailPage from './pages/PostDetailPage';
import PostInstallationPage from './pages/PostInstallationPage';
import PostInstallationDetailPage from './pages/PostInstallationDetailPage';
import PostInstallationCreatePage from './pages/PostInstallationCreatePage';
import LoginPage from './pages/LoginPage';
import UserManagementPage from './pages/UserManagementPage';
import ProfilePage from './pages/ProfilePage';
import GuidePanel from './components/GuidePanel';

function AppShell() {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <main className="app-shell">
      <header className="top-header">
        <nav className="top-nav">
          <NavLink to="/posts" end className={({ isActive }) => (isActive ? 'active' : '')}>
            AS관리
          </NavLink>
          <NavLink to="/posts/installation" className={({ isActive }) => (isActive ? 'active' : '')}>
            시공정보
          </NavLink>
          <NavLink to="/profile" className={({ isActive }) => (isActive ? 'active' : '')}>
            내 정보
          </NavLink>
          {user?.role === 'ADMIN' ? (
            <NavLink to="/users" className={({ isActive }) => (isActive ? 'active' : '')}>
              회원 관리
            </NavLink>
          ) : null}
        </nav>
        <div className="auth-status">
          <span className="auth-user">
            {user?.name || user?.username}님 로그인됨
          </span>
          <button type="button" className="secondary" onClick={handleLogout}>
            로그아웃
          </button>
        </div>
      </header>
      <div className="app-container">
        <section className="content-area">
          <Routes>
            <Route path="/" element={<Navigate to="/posts" replace />} />
            <Route path="/posts" element={<PostListPage />} />
            <Route path="/posts/new" element={<PostCreatePage />} />
            <Route path="/posts/installation" element={<PostInstallationPage />} />
            <Route path="/posts/installation/new" element={<PostInstallationCreatePage />} />
            <Route path="/posts/installation/:id" element={<PostInstallationDetailPage />} />
            <Route path="/posts/:id" element={<PostDetailPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route
              path="/users"
              element={(
                <AdminRoute>
                  <UserManagementPage />
                </AdminRoute>
              )}
            />
            <Route path="/users/register" element={<Navigate to="/users" replace />} />
          </Routes>
        </section>
        <aside className="guide-panel">
          <GuidePanel />
        </aside>
      </div>
    </main>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={(
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        )}
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
